import { render, staticRenderFns } from "./PanelClients.vue?vue&type=template&id=46dbbb52&scoped=true&"
import script from "./PanelClients.vue?vue&type=script&lang=js&"
export * from "./PanelClients.vue?vue&type=script&lang=js&"
import style0 from "./PanelClients.vue?vue&type=style&index=0&id=46dbbb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dbbb52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VFlex,VLayout,VTextField})
